var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { TemplateLabel, Icon } from "../../Layout";
import { Loader } from "../../components/Elements/Loader";

export class SearchResults extends Component {
  render() {
    const loading = /*#__PURE__*/
    _jsx("div", { className: "cs-loader-container" }, void 0, "\xA0", /*#__PURE__*/

    _jsx(Loader, {})
    );

    const results = this.props.results.toJS().map((result, index) => /*#__PURE__*/
    _jsx("div", {
      className: `item ${this.props.selected === result.sharedId ? 'is-selected' : ''}`,

      onClick: () => this.props.onClick(result.sharedId, result) }, index, /*#__PURE__*/

    _jsx("div", { className: "item-info" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "item-name" }, void 0, /*#__PURE__*/
    _jsx(Icon, { className: "item-icon item-icon-center", data: result.icon }),
    result.title
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "item-actions" }, void 0, /*#__PURE__*/
    _jsx(TemplateLabel, { template: result.template })
    )
    )
    );

    return /*#__PURE__*/(
      _jsx("div", {}, void 0,
      this.props.searching ? loading : '', /*#__PURE__*/
      _jsx("div", { className: "item-group" }, void 0, results)
      ));

  }
}








export default SearchResults;